import PResource from './p-resource.vue'

export default PResource
